<div class="d-flex justify-content-between align-items-center mb-4">
  <h1 class="h3 mb-0">{{ 'announcement.edit.title' | translate }}</h1>
</div>

<lib-announcement-form
  [announcement]="announcement()"
  [isLoading]="isSaving()"
  (announcementSubmit)="onSave($event)"
  (cancelForm)="onCancel()"
></lib-announcement-form>
